import React from 'react'
import ProductCard from '.'

export default function MultiStoreProductCard({
    list = [],
    title = '',
    areaId,
    from = '',
    viewAll = false
}) {


    return <>
        {
            list.map((item, index) => {
                const { products } = item
                if (products.length === 0) return null
                return <div
                    key={index}
                    className={index > 0 ? 'mt15' : null}
                >
                    <ProductCard
                        key={index}
                        title={title}
                        list={products}
                        storeInfo={item}
                        viewAll={viewAll}
                        from={from}
                        areaId={areaId} />
                </div>
            })
        }
    </>
}
